/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ConditionalAssumption } from '../model';
/**
 * ConditionalAssumptionApi - axios parameter creator
 * @export
 */
export const ConditionalAssumptionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets a list of conditional assumptions
         * @param {number} [entityTypeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConditionalAssumptions: async (entityTypeId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/entity/conditionalAssumptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entityTypeId !== undefined) {
                localVarQueryParameter['entityTypeId'] = entityTypeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConditionalAssumptionApi - functional programming interface
 * @export
 */
export const ConditionalAssumptionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConditionalAssumptionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets a list of conditional assumptions
         * @param {number} [entityTypeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConditionalAssumptions(entityTypeId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConditionalAssumption>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConditionalAssumptions(entityTypeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ConditionalAssumptionApi - factory interface
 * @export
 */
export const ConditionalAssumptionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConditionalAssumptionApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets a list of conditional assumptions
         * @param {number} [entityTypeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConditionalAssumptions(entityTypeId?: number, options?: any): AxiosPromise<Array<ConditionalAssumption>> {
            return localVarFp.getConditionalAssumptions(entityTypeId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConditionalAssumptionApi - object-oriented interface
 * @export
 * @class ConditionalAssumptionApi
 * @extends {BaseAPI}
 */
export class ConditionalAssumptionApi extends BaseAPI {
    /**
     * 
     * @summary Gets a list of conditional assumptions
     * @param {number} [entityTypeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConditionalAssumptionApi
     */
    public getConditionalAssumptions(entityTypeId?: number, options?: any) {
        return ConditionalAssumptionApiFp(this.configuration).getConditionalAssumptions(entityTypeId, options).then((request) => request(this.axios, this.basePath));
    }
}
